import React, { useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SuccessModal = ({ isOpen, onClose, submissionData }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen || !submissionData) return null;

  const getResponseTime = (subject) => {
    switch (subject) {
      case 'technical':
        return '12 hours';
      case 'business':
        return '48 hours';
      default:
        return '24 hours';
    }
  };

  return (
    <div className="fixed inset-0 z-1000 flex items-center justify-center p-4">
      <div 
        className="absolute inset-0 bg-background/80 backdrop-blur-md"
        onClick={onClose}
      />
      <div className="relative w-full max-w-md bg-card rounded-2xl shadow-elevation-lg animate-fade-in">
        <div className="p-8 text-center">
          {/* Success Icon */}
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-success/10 mx-auto mb-6">
            <Icon name="CheckCircle" size={32} className="text-success" />
          </div>

          {/* Success Message */}
          <h2 className="text-2xl font-semibold text-foreground mb-2">
            Message Sent Successfully!
          </h2>
          <p className="text-muted-foreground mb-6">
            Thank you for contacting us. We've received your message and will get back to you soon.
          </p>

          {/* Reference Details */}
          <div className="bg-muted/30 rounded-lg p-4 mb-6 text-left">
            <div className="space-y-3">
              <div className="flex justify-between items-center">
                <span className="text-sm font-medium text-foreground">
                  Reference Number:
                </span>
                <span className="text-sm font-mono text-primary">
                  {submissionData?.referenceNumber}
                </span>
              </div>
              
              <div className="flex justify-between items-center">
                <span className="text-sm font-medium text-foreground">
                  Subject:
                </span>
                <span className="text-sm text-muted-foreground">
                  {submissionData?.subject === 'general' && 'General Inquiry'}
                  {submissionData?.subject === 'technical' && 'Technical Support'}
                  {submissionData?.subject === 'business' && 'Business Partnership'}
                  {submissionData?.subject === 'billing' && 'Billing & Payments'}
                  {submissionData?.subject === 'feedback' && 'Feedback & Suggestions'}
                </span>
              </div>
              
              <div className="flex justify-between items-center">
                <span className="text-sm font-medium text-foreground">
                  Expected Response:
                </span>
                <span className="text-sm text-success">
                  Within {getResponseTime(submissionData?.subject)}
                </span>
              </div>
            </div>
          </div>

          {/* Additional Info */}
          <div className="bg-primary/5 rounded-lg p-4 mb-6 border border-primary/20">
            <div className="flex items-start space-x-3">
              <Icon name="Info" size={16} className="text-primary mt-0.5" />
              <div className="text-sm text-left">
                <div className="font-medium text-foreground mb-1">
                  What happens next?
                </div>
                <div className="text-muted-foreground">
                  Our support team will review your message and respond to {submissionData?.email} within the expected timeframe. Please check your spam folder if you don't see our response.
                </div>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="space-y-3">
            <Button
              onClick={onClose}
              fullWidth
              iconName="ArrowLeft"
              iconPosition="left"
            >
              Send Another Message
            </Button>
            
            <Button
              variant="ghost"
              onClick={() => {
                onClose();
                window.location.href = '/homepage';
              }}
              fullWidth
            >
              Return to Homepage
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;